import React, { useState, useEffect } from "react";
import { EllipsisOutlined } from '@ant-design/icons';
import { SelectProps, Tag, Modal, Button, Select } from 'antd';
import styled from 'styled-components'
import { tagsList, getClientTagsList, ClientTagsGroup, TagItem, getGoodsTagsList } from "./services";
import { FilterSelectPc } from "../FilterSelect/FilterSelectPc";

export interface TagsPcProps extends SelectProps {
    value?:string[]
    tagType:'goods' | 'client'
}

const TagsModal = styled(Modal)`
        width: 100%;
        .sel_tags_content{
            min-height: 80px;
            border: 1px solid #d9d9d9;
            padding: 10px;
            box-sizing: border-box;
            width:100%;
            margin-bottom: 10px;
        > div{
            margin-bottom: 10px;
        }
        }
        .silder_tags_cotent{
            display: flex;
            justify-content: space-between;
            height: 450px;
            > :nth-child(1){
                width:150px;
                border: 1px solid #d9d9d9;
                > div{
                    padding: 8px;
                    text-align: center;
                    border-bottom: 1px solid #e8e8e8;
                    cursor: pointer;
                }
            }
            > :nth-child(2){
                width: 100%;
                margin-left: 10px;
                border: 1px solid #d9d9d9;
                /* display: flex;
                flex-wrap: wrap; */
                > div{
                    border: 1px solid #d9d9d9;
                    padding: 4px 12px;
                    -webkit-border-radius: 4px;
                    border-radius: 4px;
                    margin:8px 0 0 10px;
                    cursor: pointer;
                    display: inline-block;
                    font-size: 12px;
                }
            }
        }
        .selected_tags_content{
            background: #c7c7c7;
        }
        .selected_tag_tem_content{
            background: #ec9124;
            color: white;
        }
        .btm_btn{
            border-top: 1px solid #e8e8e8;
            display: flex;
            justify-content: space-between;
            padding: 10px 16px;
        }
        &.ant-modal .ant-modal-content{
            padding: 0;
            border-radius: 4px;
        }
        .tags_content{
            padding: 24px;
        }
    
    `
const mockTags: any[] = []


const FilterTagsPc = (props: TagsPcProps) => {
    const { placeholder = "客户标签", value, onChange, tagType='client',...reset } = props;
    const [showMore, setShowMore] = useState<boolean>(false);
    const [tagsList, setTagsList] = useState<TagItem[]>([]);
    const [dataSource, setDataSource] = useState<ClientTagsGroup[]>([]);
    const [dataSelectId, setDataSelectId] = useState<string>();
    const [selectedTagIds, setSelectedTagIds] = useState<string[]>(value||[]);

    const suffixIcon = <EllipsisOutlined onClick={() => handleOpenModal()} style={{ fontSize: '20px' }} />

    const getClinetTagsList = async () => {
        const tagsTypeRequest = {
            'goods': getGoodsTagsList,
            'client': getClientTagsList
        }
        if(dataSource.length){
            return
        }
        const resTags = await tagsTypeRequest[tagType]()
        setDataSource(resTags.data.data.list)
        setDataSelectId(resTags.data.data.list[0]?.group_id)

    }

    const handleOpenModal = async () => {
        await getClinetTagsList()
        setShowMore(true)
    }

    const handleClose = () => {
        setShowMore(false);
    };

    const handleCancel = () => {

        const updatedDataSource = dataSource.map(group => ({
            ...group,
            child: group.child.map(t => ({ ...t, selected: false }))
        }));
        
        const syncTagList:TagItem[] = []

        const syncedDataSource = updatedDataSource.map(group => ({
            ...group,
            child: group.child.map(t => {
                if(value&&value.some(tag => tag === t.tag_id)){
                    syncTagList.push(t)
                    t.selected=true
                }
                return t
            })
        }));

        setTagsList(syncTagList);
        setDataSource(syncedDataSource);
        handleClose();

    };

    const handleOk = () => {
        setShowMore(false);
    };

    const toggleTagSelection = (tag: any) => {

        const isDefaultTag = mockTags.some(defaultTag => defaultTag.tag_id === tag.tag_id);
        const updatedTagsList = isDefaultTag ? [...tagsList.filter(t => t.tag_id !== tag.tag_id)] : tag.selected ? tagsList.filter(t => t.tag_id !== tag.tag_id) : [...tagsList, tag];
        setTagsList(updatedTagsList);

        const selectedIds = [...selectedTagIds];
        if (tag.selected && !isDefaultTag) {
            const index = selectedIds.indexOf(tag.tag_id);
            if (index !== -1) {
                selectedIds.splice(index, 1);
            }
        } else {
            selectedIds.push(tag.tag_id);
        }
        setSelectedTagIds(selectedIds);

        // 更新标签的 selected 属性
        const updatedDataSource = dataSource.map(group => ({
            ...group,
            child: group.child.map(t => {
                if (t.tag_id === tag.tag_id) {
                    return { ...t, selected: !t.selected };
                }
                return t;
            })
        }));
        setDataSource(updatedDataSource);
    };

    const handleGroupClick = (groupId: string) => {
        setDataSelectId(groupId);
    };

    const handleClear = () => {
        console.log("clear");
        const updatedDataSource = dataSource.map(group => ({
            ...group,
            child: group.child.map(t => ({ ...t, selected: false }))
        }));
        setDataSource(updatedDataSource);

        // 清空已选择的标签列表
        setTagsList([]);
        setSelectedTagIds([]);
        props.onChange && props.onChange([], []);
    }

    const handleTopTagClose = (tagId: string) => {
        const updatedTagsList = tagsList.filter(tag => tag.tag_id !== tagId);
        setTagsList(updatedTagsList);

        const selectedIds = selectedTagIds.filter(id => id !== tagId);
        setSelectedTagIds(selectedIds);

        // 更新标签的 selected 属性
        const updatedDataSource = dataSource.map(group => ({
            ...group,
            child: group.child.map(t => {
                if (t.tag_id === tagId) {
                    return { ...t, selected: false };
                }
                return t;
            })
        }));
        setDataSource(updatedDataSource);
    };

    const submitClientTags = () => {
        props.onChange && props.onChange(selectedTagIds, tagsList);
        handleClose()
    }
    // const options = tagsList.map((item: TagItem) => (
    //     <Select.Option disabled value={item.tag_id} key={item.tag_id}>{item.tag_name}</Select.Option>
    // ))
    const options = tagsList.map((item: TagItem) => {
        return {
            label: item.tag_name,
            value: item.tag_id
        }
    })
    return (
        <div>
            <FilterSelectPc
                mode="multiple"
                allowClear
                suffixIcon={suffixIcon}
                getPopupContainer={(triggerNode) => triggerNode.parentNode}
                onClear={handleClear}
                open={false}
                value={value}
                getInitData={getClinetTagsList}
                style={{ width: '100%' }}
                onClick={()=>{handleOpenModal()}}
                placeholder={placeholder}
                {...reset}
                options={options}
            />
               
            
            <TagsModal
                className={`filter-modal`}
                width={'800px'}
                closable={false}
                footer={null}
                open={showMore}
                onOk={handleOk}
                onCancel={handleCancel}
                maskClosable={false} // 允许点击模态框外部区域关闭模态框
            
            >
                <div>
                    <div className="tags_content">
                        {
                            tagsList.length > 0 ? <div className="sel_tags_content">
                                <div>已选择的标签:</div>
                                {
                                    tagsList.map((tag, index) => (
                                        <Tag key={tag.tag_id} onClose={() => handleTopTagClose(tag.tag_id)}>{tag.tag_name}</Tag>
                                    ))
                                }
                            </div> : null
                        }

                        <div className="silder_tags_cotent">
                            <div>
                                {
                                    dataSource.map(tag => (
                                        <div key={tag.group_id} className={dataSelectId === tag.group_id ? 'selected_tags_content' : ''} onClick={() => handleGroupClick(tag.group_id)}>
                                            {tag.group_name}
                                        </div>
                                    ))
                                }
                            </div>
                            <div>
                                {
                                    dataSource.find(tag => tag.group_id === dataSelectId)?.child.map(tag => (
                                        <div key={tag.tag_id} className={`${tag.selected && tag.selected ? 'selected_tag_tem_content' : ''}`} onClick={() => toggleTagSelection(tag)}>
                                            {tag.tag_name}
                                        </div>
                                    ))
                                }
                            </div>
                        </div>
                    </div>
                    <div className="btm_btn">
                        <div> 可使用Ctrl+F，快速查找标签</div>
                        <div>
                            <Button onClick={handleCancel}>取消</Button>
                            <Button type="primary" onClick={submitClientTags} style={{ marginLeft: '8px' }}>确定</Button>
                        </div>
                    </div>
                </div>
            </TagsModal>
        </div>
    );
};

export default FilterTagsPc;